import React from 'react'

import { cn } from '@modules/lib/lib'

export type LayerInlineMenuAction = {
  label: string
  onClick: () => void
  className?: string
  /** 回数上限に達した操作など、項目は見せたまま押させない場合に true。 */
  disabled?: boolean
}

interface LayerInlineMenuProps {
  actions: LayerInlineMenuAction[]
}

/**
 * レイヤーカード下部にポップアップ表示するインラインメニュー。
 * デザイン仕様で右寄せ表示。
 */
export const LayerInlineMenu: React.FC<LayerInlineMenuProps> = ({ actions }) => {
  if (actions.length === 0) return null
  return (
    <div
      className="absolute right-0 top-full z-10 mt-1 min-w-[8rem] rounded-md border border-[#E4E4E7] bg-white p-1 shadow-md"
      role="menu"
    >
      {actions.map((action, i) => (
        <React.Fragment key={`${i}-${action.label}`}>
          {i > 0 && <div className="-mx-1 my-1 h-px bg-[#E4E4E7]" />}
          <button
            className={cn(
              'w-full rounded-sm px-2 py-1.5 text-left text-sm hover:bg-[#F4F4F5]',
              action.disabled && 'cursor-not-allowed opacity-50 hover:bg-transparent',
              action.className,
            )}
            disabled={action.disabled}
            onClick={action.onClick}
            role="menuitem"
            type="button"
          >
            {action.label}
          </button>
        </React.Fragment>
      ))}
    </div>
  )
}
